import React, {Component} from 'react';
import styled from 'styled-components';
import { Draggable } from 'react-beautiful-dnd';


const Container = styled.div`
padding: 16px;
margin: 8px;
border-radius: 2px;
background-color: ${props => (props.isDragging ? 'lightgreen' : 'white')};
box-shadow: rgba(0, 0, 0, 0.16) 0px 6px 6px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
text-decoration: none;
background-color: rgb(202, 255, 222);
`;

const Content = styled.h3`
text-transform: capitalize;
font-weight: bold;
font-size: 19px;
margin: 0;`;


export default class Task extends Component {
  render() {
    return (
      <Draggable draggableId={this.props.task} index={this.props.index}>
        {(provided, snapshot)=> (
          <Container 
          isDragging={snapshot.isDragging} 
          {...provided.draggableProps} 
          {...provided.dragHandleProps} 
          ref={provided.innerRef}> 
            <Content> { this.props.content} </Content>
          </Container>
        )}
      </Draggable>
    )
  }
}